<template>
  <div class="card">
    <header class="header-card" v-if="fullYear">
      <p>
        {{ $t('catalogue.newProduct.tab.dispo') }}
      </p>
    </header>
    <div class="mgb-25px">
      <div class="pd-20px checkbox-custom-disabled">
        <b-checkbox v-model="produit.controleDisponibilite"
                    :disabled="isDisabled">
          {{ $t('catalogue.newProduct.controleDisponibilite') }}
        </b-checkbox>
      </div>
      <div v-if="!produit.id" class="card card-article-any has-background-background">
        <div class="card-content has-text-centered">
          <h1 class="title is-size-4">
            {{ $t('catalogue.dispo.anyDispo')}}
          </h1>
        </div>
      </div>
      <div v-else class="card-content">
        <p v-if="!isDisabled" class="mgb-20px has-text-link">
          {{ $t('catalogue.dispo.selectDispoReseau') }}
        </p>
        <div class="level">
          <div class="level-item">
            <pagination
              :firstNumber="fullYear"
              :numberDisplay="10"
              @changementPage="changementAnnee">
            </pagination>
          </div>
          <div class="level-right">
            <div class="buttons">
              <button
                class="button"
                @click="checkPermissions(permCatalogue.maj) ? popUpImportExcel = true : showPopUp()"
                :class="{'button-access-no-permission': !checkPermissions(permCatalogue.maj)}">
                <b-icon
                  icon="database-import" size="is-small" type="is-default" class="has-text-link"
                  :class="{'text-access-no-permission': !checkPermissions(permCatalogue.maj)}"/>
                <span
                  class="is-size-7 has-text-link"
                  :class="{'text-access-no-permission': !checkPermissions(permCatalogue.maj)}">
                  {{ $t('general.button.import') }}
                </span>
              </button>
              <exportExcelButton
                class="mgb-2"
                :perm="permCatalogue.exporter"
                :query="exportExcelQuery"/>
            </div>
          </div>
        </div>
        <div class="columns is-multiline is-marginless is-paddingless">
          <div class="column is-2-desktop is-1-fullhd"
               @click="changementDispo(semaine)"
               :class="{'is-cursor-pointer': !isDisabled}"
               v-for="(semaine, index) in semaineYear"
               :key="index">
            <div v-if="semaine.newMonth" class="is-size-8 has-text-default mgb-5px">
              {{ semaine.mois }}
            </div>
            <div v-else class="mgt-20px"></div>
            <div class="dispo-reseau is-size-7"
                 :class="[{'has-background-indispo' : semaine.facePrevus === 0},
                       {'has-background-dispo' : semaine.facePrevus > 0},
                       {'bordure-semaine-actuelle' : semaine.semaineActuelle > 0}]">
              <p class="has-text-weight-bold">
                {{ semaine.semaine }}
              </p>
              <p class="has-text-weight-bold" v-if="semaine.facePrevus > 0">
                {{ $t('catalogue.dispo.numberFace', {
                numberFace: semaine.facePrevus
                }) }}
              </p>
              <p v-if="semaine.facePrevus > 0" class="is-size-8">
                {{ semaine.jour }} </p>
              <p v-if="semaine.objectif" class="is-size-8">
                {{ $t('catalogue.dispo.objectif') }}
                {{ semaine.objectif | formatDevise }}
              </p>
            </div>
          </div>
        </div>
        <br>
        <b-modal v-model="popUpChangementDispo" has-modal-card class="modal"
                 v-if="popUpChangementDispo">
          <pop-up-dispo-reseau :infoSemaine="infoSemaine"
                               @reloadDispoReseau="changementAnnee(fullYear)"
          ></pop-up-dispo-reseau>
        </b-modal>
        <b-modal v-model="popUpImportExcel" has-modal-card class="modal">
          <pop-up-import-excel
            :title="$t('catalogue.popUpImportExcel.titleObjectifReseauTempo')"
            @is-update="changementAnnee(fullYear)"/>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>

import moment from 'moment';
import { createNamespacedHelpers } from 'vuex';
import Pagination from '@/components/general/pagination';
import getDispoReseauAnnee from '@/services/catalogue/genererDispoReseau';
import messageErreur from '@/services/general/messageErreur';
import popUpDispoReseau from '@/components/catalogue/dispo/p_DispoReseau';
import { EXPORT_EXCEL_OBJECTIF_RESEAU_TEMPO_PRODUIT } from '@/configuration/catalogue/produitConf';
import { CATALOGUE } from '@/configuration/permissionsBodacConf';
import formatDate from '@/services/general/formatIsoDate';
import popUpImportExcel from '@/components/catalogue/p_importExcel';
import exportExcelButton from '@/components/general/button/exportExcelButton';

const Permissions = createNamespacedHelpers('permissions');
const Societes = createNamespacedHelpers('societe');

export default {
  props: {
    produit: {
      type: Object,
      required: true,
    },
    isDisabled: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      permCatalogue: CATALOGUE,
      semaineYear: [],
      fullYear: new Date().getFullYear(),
      month: '',
      infoSemaine: {},
      popUpChangementDispo: false,
      popUpImportExcel: false,
      constantes: {
        EXPORT_EXCEL_OBJECTIF_RESEAU_TEMPO_PRODUIT,
      },
    };
  },
  components: {
    Pagination,
    popUpDispoReseau,
    popUpImportExcel,
    exportExcelButton,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Societes.mapGetters({
      agenceActive: 'agenceActive',
    }),
    exportExcelQuery() {
      const lastWeeksInYear = Math.max(
        moment(new Date(this.fullYear, 11, 31)).isoWeek(),
        moment(new Date(this.fullYear, 11, 31 - 7)).isoWeek(),
      );
      const dateDebut = moment(this.fullYear.toString() + '01', 'GGGGWW').startOf('week').toDate();
      const dateFin = moment(this.fullYear.toString() + lastWeeksInYear, 'GGGGWW').startOf('week').toDate();
      return {
        typeDonnee: EXPORT_EXCEL_OBJECTIF_RESEAU_TEMPO_PRODUIT,
        typeExport: null,
        filtres: {
          query: {
            actif: true,
            produitsId: [this.produit.id],
            dateDebut: formatDate(dateDebut),
            dateFin: formatDate(dateFin),
          },
        },
      };
    },
  },
  methods: {
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    async changementAnnee(nouvelleAnnee) {
      this.fullYear = nouvelleAnnee;
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.semaineYear = await getDispoReseauAnnee(this.produit.id, this.fullYear);
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    changementDispo(semaine) {
      if (this.isDisabled) return;
      this.infoSemaine = semaine;
      this.popUpChangementDispo = true;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      if (this.produit.id) {
        this.semaineYear = await getDispoReseauAnnee(this.produit.id, this.fullYear);
      }
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
